module.exports = __webpack_public_path__ + "img/icon7.22bca003.webp";